<template>
  <CCard>
    <CCardHeader>

      <CRow>
        <CCol col="3">
          {{$t('components.price')}}
        </CCol>
        <CCol col="2" style="text-align: start ;padding:10px 20px 0 20px ">

          <CInput
              :placeholder="$t('tables.barcode')"
              v-model="barcode_model"
              id="barcode_model"
              type="text"
              autocomplete="off"
              class="bg-secondary-input"
              @keypress.enter="search_barcode"
          />

        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>

      <AddProductPrice v-if="master_id!=0" :selected_model.sync="selected_product_detail"
                       :items="unit_model_items"
                       :master_id="master_id"
                       :fields="unit_model_fields"/>
      <CRow class="mb-5 mt-5" v-if="master_id!=0">
        <CCol v-for="(item,index) in all_product_images" :key="item.productId" col="3">
          <CCard>
            <CCardHeader class="p-0">
              <CRow>
                <CCol col="8" style="text-align: start">

                  <label><strong>{{ item.productName }}</strong></label>

                </CCol>
                <CCol col="4" style="text-align: end">

                  <CButton   class="mr-1 ml-1"
                           @click="insert_product_image(item)" type="primar"
                           size="sm" color="secondary">
                    {{ $t('buttons.submit') }}
                  </CButton>

                </CCol>


              </CRow>

            </CCardHeader>

            <CRow class="m-1 text-center">

              <vue-upload-multiple-image
                  @upload-success="uploadImageSuccess(index, ...arguments)"
                  @before-remove="beforeRemove(index, ...arguments)"
                  @edit-image="editImage(index, ...arguments)"
                  :data-images="item.files"
                  :maxImage="10"
                  :id-upload="get_image_id(index)"
                  :dragText="get_image_id(index)"
                  browseText="(or) Select"
                  primaryText="Default"
                  markIsPrimaryText="Set as default"
                  popupText="This image will be displayed as default"
                  dropText="Drop your file here ..."
              ></vue-upload-multiple-image>
            </CRow>
          </CCard>
        </CCol>
      </CRow>


    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import AddProductPrice from "./AddProductPrice.vue";
import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  name: 'Login',
  components: {
    AddProductPrice,
    VueUploadMultipleImage,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_product_detail_name: '',
      selected_product_detail: 0,
      master_id: 0,
      barcode_model:'',
      all_product_images: [],

    }
  },

  mounted() {
  },
  computed: {

  },
  methods: {
    search_barcode() {
      const formData = new FormData();
      var self = this;
      formData.append('SearchTxt', self.barcode_model);

      self.barcode_model = ""
      axios.post('GetProducts', formData, {}).then(function (response) {

        if (response.data.data.length != 1) {
          self.$root.root_validate_errors=[]
          self.$root.root_validate_errors.push(self.$t('ProductNotFound'));
          return
        }
        var node = response.data.data[0]

        console.log("node is", node)
        self.selected_product_detail = node.id


        self.selected_product_detail_name = node.productCodeName;
        self.master_id = node.masterId;
        self.get_product_images()
      })
          .catch(function (error) {

            console.log(error);
          });
    },
    dataURLtoFile(dataurl, filename) {

      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type: mime});
    },

    uploadImageSuccess(productId, formData, index, fileList) {
      // console.log('formData', formData)
      // console.log('index', index)
      // console.log('fileList', fileList)
      // console.log('productId', productId)

      this.all_product_images[productId].imgfiles = [];
      // this.all_product_images.filter(x => x.productId = productId)[0].imgIds = [];
      for (var i = 0; i < fileList.length; i++) {

        if (!fileList[i].path.startsWith("http")) {
          this.all_product_images[productId].imgfiles.push(this.dataURLtoFile(fileList[i].path, fileList[i].name));
          // this.all_product_images.filter(x => x.productId = productId)[0].imgIds.push(0);
        }
      }
      // this.all_product_images = fileList;
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(productId, index, done, fileList) {
      // console.log('index', index, fileList);
      var r = confirm("remove image");

      this.product_images = fileList;
      if (r == true) {
        this.all_product_images[productId].imgIds.splice(index, 1);
        done()
      } else {

      }
    },
    editImage(productId, formData, index, fileList) {
      this.all_product_images[productId].imgfiles = [];
      // this.all_product_images.filter(x => x.productId = productId)[0].imgIds = [];
      for (var i = 0; i < fileList.length; i++) {
        if (!fileList[i].path.startsWith("http")) {
          this.all_product_images[productId].imgfiles.push(this.dataURLtoFile(fileList[i].path, fileList[i].name));
          // this.all_product_images.filter(x => x.productId = productId)[0].imgIds.push(0);
        }
      }
    },
    get_image_id(index) {
      return "image_uploader" + index
    },
    get_product_images() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetProductImagesByMasterId";

      formData.append('ProductMasterId', this.master_id);


      axios.post(url, formData, {}).then((res) => {

        self.all_product_images = res.data.data;
        self.all_product_images.forEach((val) => {
          val.imgfiles = [];
          val.files = [];
          val.imgIds = [];
          val.imageItems.forEach((val2) => {
            var image_url = localStorage.getItem("api_address") + "/" + val2.imageName;
            var item_obj = {path: image_url, name: "image.jpg"}
            val.files.push(item_obj);
            val.imgIds.push(val2.imageId)
          });
        });
        console.log(self.all_product_images)
      })
          .catch(function (error) {
            console.log(error);
          });


    },
    insert_product_image(item) {
      console.log("product id ", item);
      if (item.imgIds == null) {
        item.imgIds = [];
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "AddProductImages";

      formData.append('ProductId', item.productId);
      formData.append('ProductMasterId', this.master_id);
      for (var i = 0; i < item.imgIds.length; i++) {
        formData.append('ImgIds[]', item.imgIds[i]);
      }
      // if(item.imgIds.length ==0){
      //     formData.append('ImgIds', '[]');
      // }
      for (i = 0; i < item.imgfiles.length; i++) {
        formData.append('Files[]', item.imgfiles[i]);
      }


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.get_product_images()

      })
          .catch(function (error) {
            console.log(error);
          });


    },


    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      var previewimg = URL.createObjectURL(this.file);
      this.previewImage = previewimg;

    },
  }
}

</script>

